import React from 'react';
import AdminSidebar from '../admin_sidebar/admin_sidebar.ui';
import './admin_page.ui.scss';

interface IAdminPage {
  title?: string;
  breadcrumb?: string;
  actions?: React.ReactNode;
  children: React.ReactNode;
}

// Shell shared by every admin screen: sidebar on the left, cream content area with a breadcrumb and title.
const AdminPage = (props: IAdminPage) => {
  const { title, breadcrumb, actions, children } = props;

  return (
    <div className="admin_page">
      <AdminSidebar />
      <div className="admin_page_content">
        {(breadcrumb || title) && (
          <div className="admin_page_header">
            <div>
              {breadcrumb && <div className="admin_page_breadcrumb">{breadcrumb}</div>}
              {title && <h1 className="admin_page_title">{title}</h1>}
            </div>
            {actions && <div className="admin_page_actions">{actions}</div>}
          </div>
        )}
        {children}
      </div>
    </div>
  );
};

export default AdminPage;
